import moment from 'moment';

const identity = entry => entry;
const formatAppointment = entry => entry === undefined
    ? 'N.D'
    : moment(entry.data).format('DD-MM-YYYY [alle ore] HH:mm');

// Equal timestamps keep the first entry, matching the previous stable sorts.
// The accessor lets callers use Strapi relations without copying each item.
export function summarizePatientAppointments(history, now = new Date(), selectEntry = identity) {
    const currentTime = now.getTime();
    let next;
    let last;
    let missed;
    let nextTime = Infinity;
    let lastTime = -Infinity;
    let missedTime = -Infinity;

    history?.forEach(record => {
        const entry = selectEntry(record);
        const time = new Date(entry.data).getTime();
        if (entry.tipologia !== 'Appuntamento') return;

        if (time > currentTime && entry.stato !== 'annullato'
            && entry.stato !== 'APPUNTAMENTO MANCATO' && time < nextTime) {
            next = entry;
            nextTime = time;
        }
        if (time <= currentTime && entry.stato === 'APPUNTAMENTO CONFERMATO' && time > lastTime) {
            last = entry;
            lastTime = time;
        }
        if (time <= currentTime && entry.stato === 'APPUNTAMENTO MANCATO' && time > missedTime) {
            missed = entry;
            missedTime = time;
        }
    });

    return {
        prossimoAppuntamento: formatAppointment(next),
        ultimoAppuntamento: formatAppointment(last),
        ultimoAppuntamentoMancato: formatAppointment(missed),
    };
}
